module.exports = __webpack_public_path__ + "static/media/ico-arrow.82f222df.svg";